import React from 'react';
import PropTypes from 'prop-types';

import { courseType } from 'utils/constants';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const CreateForm = ({onSubmit, onClose}) => {
    
  return (
    <form onSubmit={ onSubmit } >
        <DialogTitle>Add Organizations</DialogTitle>
        <DialogContent dividers>
        
          <TextField
            autoFocus
            margin="dense"
            name="title"
            label="Organization Name *"
            fullWidth
            color="warning"
          />

          <TextField
            autoFocus
            margin="dense"
            name="course_title"
            label="First Collection Title *"
            fullWidth
            color="warning"
          />

          <FormControl fullWidth  margin="dense">
            <InputLabel id="course-category-label" color="warning">Collection Type</InputLabel>
            <Select 
              labelId="course-category-label"
              label="Collection Type"
              name="course_category"
              color="warning"
              defaultValue={"sellableCollectibles"}
            > 
              {Object.values(courseType).map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <TextField
            margin="dense"
            name="admin_name"
            label="Admin name"
            fullWidth
            color="warning"
          />

          <TextField
            margin="dense"
            name="admin_email"
            label="Admin email *"
            fullWidth
            color="warning"
          />

        </DialogContent>
        <DialogActions>
          <Button color="warning" onClick={ onClose }>Cancel</Button>
          <Button variant="contained" color="primary" type="submit">Create Organization</Button>
        </DialogActions>
      </form>
  )
};

CreateForm.propTypes = {
    activeOrg: PropTypes.object,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
};

export default CreateForm;